module.exports = __webpack_public_path__ + "img/company_bg.77ef9e02.jpg";